function RotateControl() {

  return 'Rotate';
};

export default RotateControl;